export const TOTAL_ADD_CREATIVES_WITH_WRITER_STEPS = 2;
